import { render, staticRenderFns } from "./ModifierGroupEdit.vue?vue&type=template&id=baa3b78a&scoped=true"
import script from "./ModifierGroupEdit.vue?vue&type=script&lang=js"
export * from "./ModifierGroupEdit.vue?vue&type=script&lang=js"
import style0 from "./ModifierGroupEdit.vue?vue&type=style&index=0&id=baa3b78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa3b78a",
  null
  
)

export default component.exports